"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SW_RECOVERY_KEY = void 0;
exports.completeServiceWorkerHealthCheck = completeServiceWorkerHealthCheck;
exports.isServiceWorkerRecoverySession = isServiceWorkerRecoverySession;
exports.SW_RECOVERY_KEY = "__sw_recovery";
/**
 * Signal to the inline Service Worker health check (in app.ejs) that the main JS bundle
 * loaded successfully. Cancels the recovery timeout so the page won't be reloaded.
 *
 * Does NOT clear the recovery flag — it persists for the session so that
 * initServiceWorker() can skip re-registering a broken Service Worker.
 */
function completeServiceWorkerHealthCheck() {
    if (typeof __cancelSwHealthCheck === "function") {
        __cancelSwHealthCheck();
    }
}
/**
 * Returns true if the page was loaded after a Service Worker health check recovery
 * (i.e. the inline script unregistered a broken SW and reloaded).
 */
function isServiceWorkerRecoverySession() {
    try {
        return sessionStorage.getItem(exports.SW_RECOVERY_KEY) === "1";
    }
    catch (_a) {
        return false;
    }
}
